// utils/cache.js
export function getCache(key) {
    const raw = localStorage.getItem(key);
    try {
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function setCache(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

export function sortList(list) {
    // 判断字符类别：返回数字优先级（越小越靠前）
    // 0 -> digit, 1 -> lower, 2 -> upper, 3 -> chinese/other
    function charCategory(ch) {
        if (!ch) return 4; // 用于越界（短串更小）
        if (ch >= '0' && ch <= '9') return 0;
        if (ch >= 'a' && ch <= 'z') return 1;
        if (ch >= 'A' && ch <= 'Z') return 2;
        // 简单判断汉字范围，及把其它字符归到最后一类
        if (/[\u4e00-\u9fff]/.test(ch)) return 3;
        return 3;
    }

    // 比较两个普通字符（同一类别且类别为 digit/lower/upper）
    function compareSimpleChar(a, b) {
        if (a === b) return 0;
        // 对数字或字母直接按字符码比较（但小写组与大写组是分开的）
        return a < b ? -1 : 1;
    }

    // 主比较函数：比较两个 labelName 字符串
    function compareNames(sa, sb) {
        // 如果两者完全相等
        if (sa === sb) return 0;

        const la = String(sa || '');
        const lb = String(sb || '');

        const maxLen = Math.max(la.length, lb.length);

        for (let i = 0; i < maxLen; i++) {
            const ca = la[i];
            const cb = lb[i];

            // 如果某一方已经结束（短串应排在前面）
            if (ca === undefined) return -1;
            if (cb === undefined) return 1;

            const catA = charCategory(ca);
            const catB = charCategory(cb);

            // 类别不同 -> 按类别优先级决定
            if (catA !== catB) return catA - catB;

            // 同类别处理：
            if (catA === 3) {
                // 中文/其他类：为了更贴近拼音，我们直接用 localeCompare('zh')
                // 如果 localeCompare 在当前环境返回 0（非常罕见），再回退到字符码比较。
                const subA = la.slice(i);
                const subB = lb.slice(i);
                const cmp = subA.localeCompare(subB, 'zh-Hans-CN'); // 使用简体中文区域
                if (cmp !== 0) return cmp < 0 ? -1 : 1;
                // 若 localeCompare 认为相等，继续下一字符（作为回退）
                continue;
            } else {
                // 数字 / 小写 / 大写：按字符直接比较
                const ccmp = compareSimpleChar(ca, cb);
                if (ccmp !== 0) return ccmp;
                // 若相等则继续下一字符
            }
        }

        // 全部字符比较完仍然视为相等（一般不会到这里）
        return 0;
    }

    // 排序原数组
    list.sort((a, b) => {
        const sa = (a && a.labelName) ? String(a.labelName) : '';
        const sb = (b && b.labelName) ? String(b.labelName) : '';
        return compareNames(sa, sb);
    });

    return list;
}